import React from "react";
import FadeInSection from "./FadeInSection";

const EXPERIENCE = [
    {
        company: "SI Labs Pvt Ltd",
        jobTitle: "Associate Software Engineer",
        duration: "Mar 2026 — Present",
        current: true,
        desc: [
            "Promoted to Associate Software Engineer after the internship, continuing as a full-stack developer on the MERN stack (MongoDB, Express, React, Node.js).",
            "Work with third-party APIs to deliver notifications across services.",
        ],
    },
    {
        company: "SI Labs Pvt Ltd",
        jobTitle: "Software Engineer Intern",
        duration: "Sep 2025 — Mar 2026",
        desc: [
            "Built microservice applications and features end-to-end across the MERN stack (MongoDB, Express, React, Node.js).",
            "Integrated RabbitMQ message queues into backend services for asynchronous processing and inter-service communication.",
            "Integrated a third-party video streaming API.",
        ],
    },
];

const JobList = () => (
    <ol className="relative ml-1 border-l border-line">
        {EXPERIENCE.map((job, i) => (
            <li
                key={`${job.company}-${job.duration}`}
                className="relative pb-10 pl-6 last:pb-0 sm:pb-12 sm:pl-8"
            >
                {/* Timeline marker — kept outside the reveal wrapper so its
                    transform never becomes the positioning context. */}
                <span
                    aria-hidden="true"
                    className={`absolute -left-[5px] top-[7px] block h-[9px] w-[9px] rounded-full ${
                        job.current
                            ? "bg-accent ring-4 ring-accent/15"
                            : "bg-ink-faint"
                    }`}
                />

                <FadeInSection delay={`${i * 100}ms`}>
                    <p className="eyebrow mb-2">{job.duration}</p>

                    <h3 className="text-xl font-semibold text-ink">
                        {job.jobTitle}{" "}
                        <span className="font-normal text-ink-faint">@</span>{" "}
                        <span className="text-accent">{job.company}</span>
                    </h3>

                    <ul className="mt-4 max-w-prose space-y-3">
                        {job.desc.map(item => (
                            <li
                                key={item}
                                className="relative pl-6 text-[15px] leading-relaxed text-ink-dim"
                            >
                                <span
                                    aria-hidden="true"
                                    className="absolute left-0 top-[0.7em] h-px w-3 bg-accent/60"
                                />
                                {item}
                            </li>
                        ))}
                    </ul>
                </FadeInSection>
            </li>
        ))}
    </ol>
);

export default JobList;
